import { ResultApi } from '../../common/services/AppClient';

export const createFeatureFlagsPlanning =
    <Args extends unknown[], T>(preview: (...args: Args) => Promise<ResultApi<T>>) =>
    async (...args: Args): Promise<T> => {
        const result = await preview(...args);
        if (result.isErr()) {
            throw new Error(result.error.data?.title || result.error.text || 'Unable to determine processing choices.');
        }
        return result.value;
    };

export const featureFlagsPreviewKeyOf = <Args extends unknown[]>(
    _planning: (...previewArgs: Args) => Promise<unknown>,
    args: Args
): string => JSON.stringify(args);
